/**
 * <FieldEditor
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import locale from './locale';
import DropdownSelect from 'components/UI/Form/Fields/ReactSelect';
import './FieldEditor.scss';
import './FieldEditorEN.scss';
import includes from 'lodash/includes'

const TYPES = [
  { value: 'text', label: __('Text', locale), },
  { value: 'select', label: __('Select One', locale),  },
  { value: 'checkbox', label: __('Select Multiple', locale), },
];

class FieldEditor extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.addOption = this.addOption.bind(this);
    this.removeOption = this.removeOption.bind(this);
    this.onOptionChange = this.onOptionChange.bind(this);
    this.toggleRequired = this.toggleRequired.bind(this);
  }

  componentDidMount() {
    const { label } = this.props;
    if (label == '') {
      this.fieldLabelElem.focus();
    }
  }

  onChange(name, value) {
    const {
      index,
      onChange,
    } = this.props;

    onChange({
      index,
      fieldValue: {
        [name]: value,
      }
    });
  }

  toggleRequired(e) {
    const {
      required
    } = this.props;

    this.onChange('required', required === false);
  }

  addOption() {
    const {
      options,
    } = this.props;

    this.onChange('options', [ ...options, '', ]);
  }

  removeOption(optionIndex) {
    return ()=>{
      const {
        options,
      } = this.props;
      let newOptions = [ ...options ];

      newOptions.splice(optionIndex, 1);

      this.onChange('options', newOptions);
    }
  }

  onOptionChange(optionIndex) {
    return (e)=>{
      let newOptions = [ ...this.props.options ];
      newOptions[optionIndex] = e.target.value;
      this.onChange('options', newOptions);
    }
  }
  validateInput() {
    const {
      type,
      label,
      options
    } = this.props;
    if(label.length > 0) {
      if((type === 'checkbox' || type === 'select') && options.length === 0 || includes(options, '')) {
        return true;
      }
      return false;
    }else {
      return true;
    }
  }
  render() {
    const {
      index,
      type,
      label,
      options,
      required,
      saveField
    } = this.props;

    return (
      <div className='field-editor-wrapper'>
        <div className='field-editor'>
          <div className='form-group'>
            <label>{__('Type', locale)}:</label>
            <div className='fieldType'>
              <DropdownSelect value={type} onChange={(value)=>{this.onChange('type', value)}} options={TYPES} />
            </div>

            <div className='fieldRequired'>
              <label className='control'>
                {__('Set As Required', locale)}
                <input type='checkbox' checked={required} onClick={this.toggleRequired} />
                <span className='checkmark'></span>
              </label>
            </div>
          </div>

          <div className='form-group'>
            <label>{__('Label', locale)}:</label>
            <div className='fieldLabel'>
              <input
                className='form-control'
                ref={(r)=>{ if (r) this.fieldLabelElem = r }}
                onChange={(e)=>{this.onChange('label', e.target.value)}} value={label} placeholder={__('New Field', locale)}
              />
            </div>
          </div>
          { (type === 'checkbox' || type === 'select') &&
            <div className='form-group elastic'>
              <label>{__('Options', locale)}:</label>
              <div className='fieldOptions'>
                {options.map((option, index)=>{
                  return (
                    <div className='optionInput' key={index} >
                      <input
                        value={options[index]}
                        className='form-control'
                        onChange={this.onOptionChange(index)}
                        autoFocus={true}
                      />
                      <i className='fa icon-cancel remove' onClick={this.removeOption(index)}></i>
                    </div>
                  );
                })}
                <a onClick={this.addOption}>{__('Add Option', locale)}</a>
              </div>
            </div>
          }
          <button className='btn btn-primary btn-sm' disabled={this.validateInput()} onClick={() => {saveField()}}>{__('Save', locale)}</button>
        </div>
      </div>
    )
  }
}

export default FieldEditor;



// WEBPACK FOOTER //
// ./src/components/UI/CustomField/FieldEditor.js